import React from "react";
import { Link } from "react-router";

export default function AuthLayout({ children }) {
  return (
    <div className="relative p-6 bg-white z-1 sm:p-0">
      <div className="relative flex flex-col justify-center w-full h-screen lg:flex-row sm:p-0">
        {children}
        <div className="items-center hidden w-full h-full lg:w-1/2 bg-[#0166b1] lg:grid">
          <div className="relative flex items-center justify-center z-1">
            <div className="flex flex-col items-center max-w-lg">
              <Link to="/" className="block">
                <img
                  src="../..//Assets/Kebs Logo.png"
                  alt="Logo"
                  width={238}
                  height={48}
                />
              </Link>
              <p className="text-center text-white text-4xl font-bold">
                Kenya Bureau of Standards
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
